import { css, StyleSheet } from 'aphrodite';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useIsCustomerAssistantEmbedMode } from '../../hooks/useIsCustomerAssistantEmbedMode';
import { useCustomPageStyleFooterQuery } from '../../queries/useCustomPageStyleFooterQuery';
import { useCustomPageStyleHeaderQuery } from '../../queries/useCustomPageStyleHeaderQuery';
import { usePublicAIConversationAgentTemplateQuery } from '../../queries/usePublicAIConversationAgentTemplateQuery';

interface CustomerAssistantLayoutProps {
	children: React.ReactNode;
}

export function CustomerAssistantLayout({ children }: CustomerAssistantLayoutProps) {
	const { agentTemplateId } = useParams<{ agentTemplateId: string }>();
	const isEmbedMode = useIsCustomerAssistantEmbedMode();
	const agentTemplateQuery = usePublicAIConversationAgentTemplateQuery({
		id: agentTemplateId,
		enabled: Boolean(agentTemplateId),
	});
	const customPageStyleHeaderQuery = useCustomPageStyleHeaderQuery({
		enabled: Boolean(agentTemplateId) && !isEmbedMode,
		agentTemplateId,
	});
	const customPageStyleFooterQuery = useCustomPageStyleFooterQuery({
		enabled: Boolean(agentTemplateId) && !isEmbedMode,
		agentTemplateId,
	});

	useEffect(() => {
		if (agentTemplateQuery.data?.name) {
			document.title = agentTemplateQuery.data?.name;
		}
	}, [agentTemplateQuery.data?.name]);

	return (
		<div className={css(s.root)}>
			<div className={css(s.main)}>
				{!isEmbedMode && customPageStyleHeaderQuery.data ? (
					<div dangerouslySetInnerHTML={{ __html: customPageStyleHeaderQuery.data }} />
				) : null}
				<div className={css(s.content)}>{children}</div>
			</div>
			{!isEmbedMode && customPageStyleFooterQuery.data ? (
				<div dangerouslySetInnerHTML={{ __html: customPageStyleFooterQuery.data }} />
			) : null}
		</div>
	);
}

const s = StyleSheet.create({
	root: {
		width: '100%',
	},
	main: {
		display: 'flex',
		flexDirection: 'column',
		height: '100dvh',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		minHeight: 0,
	},
	slotContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		flex: 1,
		maxWidth: 768,
		width: '100%',
		margin: '0 auto',
		padding: 16,
		overflow: 'auto',
	},
});
